// extracted by mini-css-extract-plugin
export default {"SSOButton":"SSOButton_SSOButton__61oSH"};